<template>
  <modal-template
    ref="modal"
    modal-size="lg"
    title="Orçamento de Persianas"
    type-modal="blinds_quotation_modal"
  >
    <d-form class="modal-content__main">

      <d-form-row>

        <!-- Type -->
        <d-col md="2" class="form-group">
          <label>Tipo de Persiana</label>
          <d-select v-model="model.blinds.blinds_type_id" @change="changeBlindsTypes()" :state="hasErrorFiled('blinds_type_id')" :options="blindsTypes" value-field="id" text-field="name" required></d-select>
          <d-form-invalid-feedback>Tipo de persiana é obrigatório</d-form-invalid-feedback>
        </d-col>

        <!-- Description -->
        <d-col md="10" class="form-group">
          <label>Descrição</label>
          <d-form-input type="text" placeholder="Descrição" :state="hasErrorFiled('description')" v-model="model.description" required/>
          <d-form-invalid-feedback>Descrição é obrigatória</d-form-invalid-feedback>
        </d-col>

      </d-form-row>
      <!-- Cortain -->
      <template v-if="model.blinds.blinds_type_id === 1">
        <d-form-row>

          <!-- Width -->
          <d-col md="2" class="form-group">
            <label>Largura</label>
            <d-form-input
              type="number"
              class="text-right"
              placeholder="Largura"
              v-model="model.blinds.width"
              required
              :state="hasErrorFiled('width')"
              @change="calcPelmet(model)"
              min="0"
              step="0,01"/>
            <d-form-invalid-feedback>Largura é obrigatória</d-form-invalid-feedback>
          </d-col>

          <!-- Height -->
          <d-col md="2" class="form-group">
            <label>Altura</label>
            <d-form-input
              type="number"
              class="text-right"
              placeholder="Largura"
              v-model="model.blinds.height"
              required
              :state="hasErrorFiled('height')"
              min="0"
              step="0,01"/>
             <d-form-invalid-feedback>Altura é obrigatória</d-form-invalid-feedback>
          </d-col>

          <!-- Unit -->
          <d-col md="1" class="form-group">
            <label>Unid.</label>
            <d-form-input type="text" class="text-center" placeholder="Unid." v-model="model.unit_type" readonly/>
          </d-col>

          <!-- Quantity -->
          <d-col md="2" class="form-group">
            <label>Quantidade</label>
            <d-form-input type="number" class="text-center form-control" placeholder="Qtd." v-model="model.quantity" @change="calcTotal(model)" required/>
            <d-form-invalid-feedback>Quantidade é obrigatória</d-form-invalid-feedback>
          </d-col>

          <!-- Value -->
          <d-col class="form-group">
            <label>Valor</label>
            <d-input-group prepend="R$">
              <input-currency
                model-index="value"
                placeholder="Valor"
                :model="model"
                :state="hasErrorFiled('value')"
                required
                :on-change="calcTotal"
              ></input-currency>
            <d-form-invalid-feedback>Valor é obrigatório</d-form-invalid-feedback>
            </d-input-group>
          </d-col>

          <!-- Total -->
          <d-col class="form-group">
            <label>Total</label>
            <d-input-group prepend="R$">
              <input-currency
                model-index="total"
                placeholder="Total"
                :model="model"
              ></input-currency>
            </d-input-group>
          </d-col>

        </d-form-row>

        <d-form-row>

          <!-- Collection -->
          <d-col md="4" class="form-group">
            <label>Coleção</label>
            <d-form-input type="text" placeholder="Coleção" v-model="model.blinds.collection" required :state="hasErrorFiled('collection')"/>
            <d-form-invalid-feedback>Coleção é obrigatório</d-form-invalid-feedback>
          </d-col>

          <!-- Color -->
          <d-col md="4" class="form-group">
            <label>Tecido/Cor</label>
            <d-form-input type="text" placeholder="Tecido" v-model="model.blinds.color" required :state="hasErrorFiled('color')"/>
            <d-form-invalid-feedback>Tecido/cor é obrigatório</d-form-invalid-feedback>
          </d-col>

          <!-- Gap -->
          <d-col md="2" class="form-group">
            <label>Dentro de vão?</label>
            <d-checkbox toggle @change="toggleCheckbox('gap')" :checked="(model.blinds.gap == 1)" class="custom-toggle-sm">Sim</d-checkbox>
          </d-col>

        </d-form-row>

      </template>
      <template v-if="model.blinds.blinds_type_id !== 1">
        <d-form-row>

          <!-- Width -->
          <d-col md="3" class="form-group">
            <label>Largura</label>
            <d-form-input type="number" class="text-right" placeholder="Largura" v-model="model.blinds.width" @change="calcTotalByArea(model)" required :state="hasErrorFiled('width')" min="0" step="0,01"/>
            <d-form-invalid-feedback>Largura é obrigatória</d-form-invalid-feedback>
          </d-col>

          <!-- Height -->
          <d-col md="3" class="form-group">
            <label>Altura</label>
            <d-form-input type="number" class="text-right" placeholder="Largura" v-model="model.blinds.height" @change="calcTotalByArea(model)" required :state="hasErrorFiled('height')" min="0" step="0,01"/>
            <d-form-invalid-feedback>Altura é obrigatória</d-form-invalid-feedback>
          </d-col>

          <!-- Parapet -->
          <d-col md="3" class="form-group">
            <label>Parapeito</label>
            <d-form-input type="number" class="text-right" placeholder="Parapeito" v-model="model.blinds.parapet" required min="0" step="0,10"/>
            <d-form-invalid-feedback>Parapeito é obrigatório</d-form-invalid-feedback>
          </d-col>

          <!-- Area -->
          <d-col md="3" class="form-group">
            <label>Área</label>
            <d-input-group append="m²">
              <d-form-input readonly class="text-right" placeholder="Área" v-model="model.blinds.area"/>
            </d-input-group>
          </d-col>

        </d-form-row>

        <d-form-row>
          <!-- Engine Side --><!-- Show if are horizontal blinds -->
          <d-col md="2" class="form-group" v-if="model.blinds.blinds_type_id === 2">
            <label>Lado do comando</label>
            <d-select v-model="model.blinds.engineSide">
              <option value="left">Esquerda</option>
              <option value="right">Direita</option>
            </d-select>
          </d-col>

          <!-- Opening --> <!-- Show if are vertical blinds -->
          <d-col md="2" class="form-group" v-if="model.blinds.blinds_type_id === 5">
            <label>Abertura</label>
            <d-select v-model="model.blinds.opening" :options="opening" required></d-select>
          </d-col>

          <d-col md="8" class="form-group form-row m-0 p-0">

            <!-- Collection -->
            <d-col md="6" class="form-group">
              <label>Coleção</label>
              <d-form-input type="text" placeholder="Coleção" v-model="model.blinds.collection" required :state="hasErrorFiled('collection')"/>
              <d-form-invalid-feedback>Coleção é obrigatório</d-form-invalid-feedback>
            </d-col>

            <!-- Color -->
            <d-col md="6" class="form-group">
              <label>Tecido/Cor</label>
              <d-form-input type="text" placeholder="Tecido" v-model="model.blinds.color" required :state="hasErrorFiled('color')"/>
              <d-form-invalid-feedback>Tecido/cor é obrigatório</d-form-invalid-feedback>
            </d-col>

          </d-col>

          <!-- Gap -->
          <d-col md="2" class="form-group">
            <label>Dentro de vão?</label>
            <d-checkbox toggle @change="toggleCheckbox('gap')" :checked="(model.blinds.gap == 1)" class="custom-toggle-sm">Sim</d-checkbox>
          </d-col>

        </d-form-row>

        <!-- Roller or vertical -->
        <d-form-row v-if="model.blinds.blinds_type_id === 3 || model.blinds.blinds_type_id === 5">

          <!-- <d-col cols="auto" class="form-group form-row m-0 p-0"> -->
          <!-- Pelmet -->
          <d-col md="1" class="form-group">
            <label>Tem Bandô?</label>
            <d-checkbox toggle @change="toggleCheckbox('pelmet')" :checked="(model.blinds.pelmet == 1)" class="custom-toggle-sm">Sim</d-checkbox>
          </d-col>

          <template v-if="model.blinds.pelmet && model.blinds.blinds_type_id === 5">

            <!-- Pelmet type -->
            <d-col md="3" class="form-group">
              <label>Tipo do bandô</label>
              <d-select v-model="model.blinds.pelmet_type" :options="pelmets" @change="calcTotalByArea(model)"></d-select>
            </d-col>

          </template>

          <template v-if="model.blinds.blinds_type_id === 3">

            <!-- Thickness -->
            <d-col md="2" class="form-group">
              <label>Espessura</label>
              <d-select v-model="model.blinds.thickness" :options="thicknesses"></d-select>
            </d-col>

          <!-- </d-col> -->

            <!-- Furl -->
            <d-col md="2" class="form-group">
              <label>Enrolamento</label>
              <d-select v-model="model.blinds.furl">
                <option value="normal">Normal</option>
                <option value="inverted">Invertido</option>
              </d-select>
            </d-col>

            <!-- Reducer -->
            <d-col md="1" class="form-group">
              <label>Tem redutor?</label>
              <d-checkbox toggle @change="toggleCheckbox('reducer')" :checked="(model.blinds.reducer == 1)" class="custom-toggle-sm">Sim</d-checkbox>
            </d-col>

          </template>

        </d-form-row>

        <!-- Roller or Roman -->
        <d-form-row v-if="model.blinds.blinds_type_id === 3 || model.blinds.blinds_type_id === 4">

          <!-- <d-col md="9" class="form-group form-row m-0 p-0"> -->

          <!-- Engine -->
          <d-col md="1" class="form-group">
            <label>Tem motor?</label>
            <d-checkbox toggle @change="toggleCheckbox('hasEngine')" :checked="(model.blinds.hasEngine == 1)" class="custom-toggle-sm">Sim</d-checkbox>
          </d-col>

          <template v-if="model.blinds.hasEngine">

            <!-- Engine volts -->
            <d-col md="3" class="form-group">
              <label>Volts do Motor</label>
              <d-form-input type="text" placeholder="Volts do motor" v-model="model.blinds.engineVolts" />
            </d-col>

          </template>

          <!-- Engine Side -->
          <d-col md="3" class="form-group">
            <label>Lado do comando</label>
            <d-select v-model="model.blinds.engineSide">
              <option value="left">Esquerda</option>
              <option value="right">Direita</option>
            </d-select>
          </d-col>

          <!-- </d-col> -->

        </d-form-row>

        <d-form-row>

          <d-col md="3" class="form-group form-row m-0 p-0">

            <!-- Unit -->
            <d-col md="6" class="form-group">
              <label>Unid.</label>
              <d-form-input type="text" class="text-center" placeholder="Unid." v-model="model.unit_type" readonly/>
            </d-col>

            <!-- Quantity -->
            <d-col md="6" class="form-group">
              <label>Quantidade</label>
              <d-form-input type="number" class="text-center form-control" placeholder="Qtd."
                v-model="model.quantity" @change="calcTotalByArea(model)" required/>
              <d-form-invalid-feedback>Quantidade é obrigatória</d-form-invalid-feedback>
            </d-col>

          </d-col>

          <!-- Value -->
          <d-col md="3" class="form-group">
            <label>Valor</label>
            <d-input-group prepend="R$">
              <input-currency
                model-index="value"
                placeholder="Valor"
                :model="model"
                :on-change="calcTotalByArea"
                :state="hasErrorFiled('value')"
                required
              ></input-currency>
            <d-form-invalid-feedback>Valor é obrigatório</d-form-invalid-feedback>
            </d-input-group>
          </d-col>

          <!-- Additional Cost -->
          <d-col md="3" class="form-group">
            <label>Custom adicional</label>
            <d-input-group prepend="R$">
              <input-currency
                model-index="additional_cost"
                placeholder="Custo adicional"
                :model="model.blinds"
                :on-change="addAdditionalCost"
              ></input-currency>
            </d-input-group>
          </d-col>

          <!-- Total -->
          <d-col md="3" class="form-group">
            <label>Total</label>
            <d-input-group prepend="R$">
              <input-currency
                model-index="total"
                placeholder="Total"
                :model="model"
              ></input-currency>
            </d-input-group>
          </d-col>

        </d-form-row>

      </template>

      <d-form-row>

        <!-- Observation -->
        <d-col md="12" class="form-group">
          <label>Observação</label>
          <textarea v-model="model.blinds.comment" :rows="5" class="form-control"></textarea>
        </d-col>

      </d-form-row>

    </d-form>

    <div slot="actions" class="modal-content__control">
      <d-button type="button" @click="close()" class="btn btn-sm btn-secondary mr-4">Cancelar</d-button>
      <d-button type="button" @click="save()" class="btn btn-sm btn-primary">Salvar</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import InputCurrency from '_shared/InputCurrency.vue';
import ModalTemplate from '_shared/Modal.vue';
import MixinValidateForm from '_common/mixins/ValidateForm';
import MixinQuotationCalc from '_common/mixins/QuotationCalc';
import MixinQuotationBlindsCalc from '_common/mixins/QuotationBlindsCalc';
import { ROW, _UPDATE_QUOTATION_ROWS_, _OPEN_MODAL_, PELMETS, THICKNESSES, OPENING, BLINDS } from '../QuotationModel';

const MODEL = { ...ROW, blinds: { ...BLINDS } };
export default {
  name: 'blinds-quotation-modal',
  mixins: [MixinQuotationCalc, MixinValidateForm, MixinQuotationBlindsCalc],
  data() {
    return {
      loading: false,
      model: { ...MODEL },
      errors: {
        color: { required: false, field: 'blinds.color' },
        value: { required: false },
        width: { required: false, field: 'blinds.width' },
        height: { required: false, field: 'blinds.height' },
        collection: { required: false, field: 'blinds.collection' },
        description: { required: false },
        blinds_type_id: { required: false, field: 'blinds.blinds_type_id' },
      },
      opening: OPENING,
      pelmets: PELMETS,
      thicknesses: THICKNESSES,
    };
  },
  components: {
    InputCurrency,
    ModalTemplate,
  },
  computed: {
    blindsTypes() {
      const { blindsTypes } = this.$store.state.quotation;
      const typeEmpty = { id: null, slug: '', name: 'Selecione um tipo' };
      if (blindsTypes) {
        return [{ ...typeEmpty }, ...blindsTypes];
      }
      return [{ ...typeEmpty }];
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getBlindsTypes',
    ]),
    addAdditionalCost() {
      this.calcTotalWithAdditionalCost(this.model);
    },
    changeBlindsTypes() {
      setTimeout(() => {
        this.model.unit_type = 'm²';
        if (this.model.blinds.blinds_type_id === 1) {
          this.model.unit_type = 'un';
        }

        this.model.blinds.pelmet = false;
        this.model.blinds.reducer = false;
        this.model.blinds.hasEngine = false;
        this.model.blinds.additional_cost = 0;
        this.calcAdditionalCost(this.model);
      }, 50);
    },
    cleanModel() {
      this.model = { ...MODEL };
      this.submitted = false;
    },
    close() {
      this.setToggle({ type: 'blinds_quotation_modal', bool: false });
    },
    getType() {
      if (this.$store.state.quotation.blindsTypes == null) {
        this.setToggle({ type: 'progress', bool: true });
        this.getBlindsTypes()
          .then(() => {
            this.setToggle({ type: 'progress', bool: false });
          });
      }
    },
    save() {
      if (this.checkForm()) {
        Events.$emit(_UPDATE_QUOTATION_ROWS_, this.model);
        this.cleanModel();
        this.close();
      }
    },
    toggleCheckbox(field) {
      const value = (this.model.blinds[field]) ? 0 : 1;
      this.$set(this.model.blinds, field, value);
      if (field !== 'gap') {
        this.calcAdditionalCost(this.model);
      }
      return field;
    },
  },
  mounted() {
    Events.$on(_OPEN_MODAL_, ({ quotation, type }) => {
      if (type === 'blinds_quotation_modal') {
        this.model = { ...quotation };
        if (!this.model.blinds) {
          this.model.blinds = { ...BLINDS };
        }
      }
    });
    this.getType();
    this.getSettings();
  },
};
</script>
<style lang="scss">
@media (min-width: 992px) {
  .modal-lg {
      max-width: 1100px;
  }
}
</style>
<style lang="scss" scoped>
  .modal-sm {
    p {
      margin-bottom: 0;
    }
  }
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}
</style>
